import React from 'react';
import { SimpleShowLayout, TextField, EmailField, DateField, BooleanField, FunctionField } from 'react-admin';
import Avatar from '@material-ui/core/Avatar';


const placeholderAvatar = '/images/silhouette.png';


const UserAvatarField = ({ record = {}, size = 100 }) => {
  const src = record.picture || placeholderAvatar;
  const alt = `${record.firstName || ''} ${record.lastName || ''}`.trim() || 'User avatar';
  return (
    <Avatar
      src={src}
      alt={alt}
      imgProps={{
        onError: e => {
          e.target.onerror = null;
          e.target.src = placeholderAvatar;
        },
      }}
      style={{ width: size, height: size, marginBottom: 16 }}
    />
  );
};


const GeneralInfoTab = ({ record }) => {
  if (!record) return null;
  return (
    <>
      <SimpleShowLayout record={record}>
        <FunctionField label="Avatar" render={() => <UserAvatarField record={record} size={100} />} />
        <TextField source="id" label="ID" />
        <TextField source="firstName" label="Нэр" />
        <TextField source="lastName" label="Овог" />
        <EmailField source="email" label="И-мэйл" />
        <TextField source="phoneNumber" label="Утасны дугаар" />
        <TextField source="social" label="Social" />
        <TextField source="type" label="Төрөл" />
        <DateField source="createdAt" label="Үүсгэсэн" showTime />
        <DateField source="lastLogin" label="Сүүлд нэвтэрсэн" showTime />
        <BooleanField source="isDeleted" label="Устгагдсан эсэх" />
      </SimpleShowLayout>
    </>
  )
}
export default GeneralInfoTab;                  
